import { FC } from 'react';

import { Form, FormInstance, Table, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import useCurrency from '@/contexts/useCurrency';
import { PlantForm } from '@/types/plant';

type Props = {
  disabled?: boolean;
  form: FormInstance<PlantForm>;
};

const ParticipationFiT: FC<Props> = () => {
  const { t } = useTranslation();
  const { currencySymbol } = useCurrency();
  const theme = useTheme();

  const columns = [
    {
      title: t('plants.form.participationFiT.table.columnName'),
      dataIndex: 'columnName',
      key: 'columnName',
      width: 300,
    },
    {
      title: t('plants.form.participationFiT.table.description'),
      dataIndex: 'description',
      key: 'description',
    },
  ];

  const row3Description = (
    <>
      {t('plants.form.participationFiT.table.row3.descriptionIntro')}
      <ul style={{ marginBottom: 0, marginTop: 8, paddingLeft: 20 }}>
        <li>{t('plants.form.participationFiT.table.row3.option0')}</li>
        <li>{t('plants.form.participationFiT.table.row3.option1')}</li>
        <li>{t('plants.form.participationFiT.table.row3.option2')}</li>
      </ul>
    </>
  );

  const dataSource = [
    {
      key: '1',
      columnName: t('plants.form.participationFiT.table.row1.columnName', {
        symbol: currencySymbol,
      }),
      description: t('plants.form.participationFiT.table.row1.description'),
    },
    {
      key: '2',
      columnName: t('plants.form.participationFiT.table.row2.columnName', {
        symbol: currencySymbol,
      }),
      description: t('plants.form.participationFiT.table.row2.description'),
    },
    {
      key: '3',
      columnName: t('plants.form.participationFiT.table.row3.columnName'),
      description: row3Description,
    },
  ];

  return (
    <Form.Item<PlantForm>
      wrapperCol={{ span: 24 }}
      className="p-16 pb-40"
      style={{
        border: '0.5px solid',
        borderRadius: '10px',
        borderColor: theme.colors.grayLightAccent,
      }}
    >
      <Typography.Title level={5} style={{ marginTop: 0, marginBottom: 12 }}>
        {t('plants.form.participationFiT.title')}
      </Typography.Title>
      <Typography.Paragraph style={{ marginBottom: 16 }} type="secondary">
        {t('plants.form.participationFiT.intro')}
      </Typography.Paragraph>
      <Table
        columns={columns}
        dataSource={dataSource}
        pagination={false}
        size="small"
        bordered
      />
    </Form.Item>
  );
};

export default ParticipationFiT;
